<div class="custom-snackbar d-flex flex-column s-sm">
    <div class="d-flex flex-column s-xs">
        <div class="d-flex align-items-center snackbar-header s-xs">
            <div class="d-flex align-item-center">
                <i-tabler [name]="data.icon" class="main-icon" [className]="data.color" [ngClass]="{'filled':true}"></i-tabler>
            </div>
            <div class="flex-grow-1">
                <!-- data.title when the caller named the outcome; otherwise the generic
                     Success/Failed every existing call already relies on. -->
                <p class="body-md text-text-neutral-strong font-weight-semibold">{{ data.title || (data.type === 'success' ? 'Success' : 'Failed') }}</p>
            </div>
            <div class="cursor-pointer">
                <i-tabler name="x" class="main-icon icon-icon-neutral-weak" (click)="dismiss()" (keydown)="commonService.onKeyDown($event)"></i-tabler>
            </div>
        </div>
        <div class="snackbar-content">
            <p class="body-sm font-weight-regular text-text-neutral-strong">{{ data.message }}</p>
        </div>
        <div class="progressbar" [ngClass]="{'greenprogress': data.type === 'success', 'redprogressbar': data.type !== 'success'}">
            <mat-progress-bar *ngIf="isProgressVisible" mode="determinate" [value]="progress"></mat-progress-bar>
        </div>
        
    </div>
  
</div>
